import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinbagmane() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Bagmane Tech Park C.V. Raman Nagar',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Bagmane Tech Park C.V. Raman Nagar',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Bagmane Tech Park C.V. Raman Nagar, catering to the transportation needs of IT companies, corporate offices, and business centers in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Bagmane Tech Park C.V. Raman Nagar.',

    top: 'Top Places to Visit in Bagmane with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Bagmane Tech Park",
    "description": "Bagmane Tech Park is one of Bangalore’s premier IT business hubs, housing global and Indian tech companies in modern office complexes. Known for its well-planned infrastructure, landscaped open spaces, and corporate facilities, it provides an efficient working environment for IT professionals. The park features food courts, cafés, banks, and connectivity to major transport routes, making it a key center for business and innovation in Bangalore."
  },
  {
    "title": "Bagmane Green Spaces",
    "description": "Surrounding Bagmane Tech Park are landscaped gardens and small green zones that provide employees and visitors with peaceful spots for relaxation, outdoor meetings, and short breaks. These spaces enhance the corporate environment, offering a refreshing atmosphere amid the busy IT campus, perfect for walking, quick refreshment, or casual networking."
  },
  {
    "title": "Nearby Old Airport Road Dining & Cafés",
    "description": "The area around Bagmane Tech Park, including Old Airport Road, is dotted with a variety of restaurants, cafés, and eateries. Professionals and visitors enjoy local and international cuisines, coffee shops, and casual dining options. The convenience of nearby dining makes it a popular area for lunch meetings, casual hangouts, and evening relaxation after work."
  },
  {
    "title": "HAL Heritage Centre & Aerospace Museum",
    "description": "Located close to Bagmane Tech Park, the HAL Heritage Centre showcases India’s aerospace history, featuring aircraft displays, historical exhibits, and educational insights into aviation technology. Visitors, students, and enthusiasts can explore vintage planes, interactive exhibits, and gain knowledge about India’s aeronautical achievements, making it a unique attraction near the IT hub."
  },
  {
    "title": "Indiranagar Nightlife",
    "description": "Indiranagar, a short distance from Bagmane Tech Park, is one of Bangalore’s liveliest neighborhoods for nightlife. It offers pubs, bars, lounges, and live music venues, attracting young professionals and visitors for evening entertainment. The vibrant social scene complements the daytime corporate environment, providing a balanced work-and-leisure experience for Bagmane employees."
  },
  {
    "title": "Shivaji Nagar Local Markets",
    "description": "Nearby markets and retail spaces in Shivaji Nagar provide shopping options for everyday essentials, electronics, and local goods. Employees and residents in the area frequently visit these markets for quick shopping, snacks, and daily needs. The markets reflect Bangalore’s urban culture and provide convenient access for nearby office-goers."
  },
  {
    "title": "HAL Airport Road Parks",
    "description": "Several small parks and jogging paths along HAL Airport Road offer opportunities for morning walks, running, and relaxation. These green stretches are frequented by local residents and corporate employees for fitness and leisure activities. The tree-lined paths and quiet corners provide a welcome escape from office stress and city traffic."
  },
  {
    "title": "Bagmane Tech Park Community Events",
    "description": "Bagmane Tech Park occasionally hosts corporate events, cultural celebrations, and community engagement activities within its campus. These events include team-building exercises, tech talks, cultural festivals, and wellness programs. They provide networking opportunities, foster workplace camaraderie, and enhance the overall corporate experience for employees."
  },
  {
    "title": "Hoysala Temple Replica at Nearby Areas",
    "description": "Within a short drive from Bagmane Tech Park, some areas feature replicas or small shrines inspired by Hoysala-style temple architecture. These sites offer glimpses of Karnataka’s traditional craftsmanship and spiritual ambiance, allowing visitors and employees to experience cultural heritage alongside modern corporate infrastructure."
  },
  {
    "title": "Nearby Fitness & Wellness Centers",
    "description": "The vicinity of Bagmane Tech Park includes multiple gyms, yoga studios, and wellness centers catering to IT professionals and residents. These facilities offer fitness programs, health workshops, and recreational activities, promoting a balanced lifestyle. They are particularly popular for post-work relaxation, morning routines, and weekend fitness engagements."
  }
],


"services": [
{
"name": "Bagmane IT Park Cab",
"description": "Bagmane IT Park Cab provides a fully managed corporate cab service designed specifically for employees, executives, and visitors traveling to Bagmane Tech Park. With a large fleet of sedans, SUVs, and shuttle vehicles, the service ensures punctual pick-up/drop routes, smart dispatching, GPS-enabled tracking, and professionally trained chauffeurs. It supports multi-shift IT operations, offers flexible routing, and delivers a seamless, safe, and premium mobility experience across all Bagmane campuses."
},
{
"name": "C.V. Raman Nagar Employee Transport",
"description": "C.V. Raman Nagar Employee Transport offers comprehensive workforce mobility solutions for IT offices, corporate campuses, and industrial facilities in the region. The service includes real-time vehicle monitoring, shift-based transport planning, centralized scheduling, and highly reliable driver operations. Built for companies with varying workforce sizes, it ensures safe, timely, and efficient daily commuting for employees traveling to and from C.V. Raman Nagar."
},
{
"name": "Corporate Shuttle Bagmane",
"description": "Corporate Shuttle Bagmane delivers high-capacity shuttle services using AC minibuses and vans designed for large teams commuting to Bagmane Tech Park. It features optimized routing, trip clustering, automated attendance integration, and strict safety protocols. Ideal for IT companies with bulk staff movement, the service ensures smooth, dependable, and well-organized multi-route shuttle operations throughout the day."
},
{
"name": "Office Pickup Drop Bagmane",
"description": "Office Pickup Drop Bagmane provides structured daily commute solutions with pre-planned routes, professional chauffeurs, and punctual scheduling for employees working in Bagmane Tech Park. It supports fixed, flexible, and rotating shifts, offering real-time tracking, efficient routing, and seamless office travel for all workforce categories."
},
{
"name": "Employee Cab Bagmane Tech Park",
"description": "Employee Cab Bagmane Tech Park offers dedicated staff transportation services with modern vehicles, trained drivers, and tech-enabled navigation systems. Designed for IT and corporate employees, it ensures safe, comfortable, and timely travel supported by intelligent scheduling, route optimization, and end-to-end fleet management."
},
{
"name": "Business Cab Bagmane",
"description": "Business Cab Bagmane delivers executive travel solutions for corporate meetings, airport transfers, client visits, and inter-office mobility. With premium vehicles, experienced chauffeurs, and quick dispatching, it caters to business travelers seeking comfort, reliability, and punctual service within and beyond Bagmane Tech Park."
},
{
"name": "Monthly Staff Shuttle Bagmane",
"description": "Monthly Staff Shuttle Bagmane offers long-term shuttle mobility contracts for companies requiring regular employee transportation. The service includes dedicated routes, driver deployment, vehicle maintenance, GPS monitoring, and 24/7 coordination support. It ensures uninterrupted and cost-efficient monthly commute solutions for organizations in Bagmane Tech Park."
},
{
"name": "Best Corporate Cabs Bagmane",
"description": "Best Corporate Cabs Bagmane provides top-tier corporate mobility with premium vehicles, verified chauffeurs, high service standards, and strong safety compliance. Ideal for senior executives, managerial staff, and business visitors, the service ensures a smooth and professional travel experience across all major business hubs connected to Bagmane Tech Park."
},
{
"name": "Affordable Cab Bagmane",
"description": "Affordable Cab Bagmane offers budget-friendly corporate transport without compromising on reliability, safety, or comfort. Ideal for startups, SMEs, and mid-sized tech companies, it features efficient routes, clean vehicles, and trained drivers, making daily commute operations both economical and smooth."
},
{
"name": "Outstation Cab Bagmane",
"description": "Outstation Cab Bagmane provides long-distance corporate travel services for business meetings, client visits, factory tours, and executive travel. With comfortable vehicles, experienced chauffeurs, interstate permits, and real-time tracking, it ensures safe and convenient outstation mobility for companies in Bagmane Tech Park."
},
{
"name": "Sedan Cab Bagmane",
"description": "Sedan Cab Bagmane offers executive-level sedans ideal for manager travel, airport runs, client movement, and premium daily commute. Each sedan is well-maintained, features plush interiors, and is operated by professional drivers to provide a comfortable and refined travel experience."
},
{
"name": "SUV Cab Bagmane",
"description": "SUV Cab Bagmane provides spacious, durable, and high-comfort SUVs perfect for team travel, senior executive movement, outstation business trips, and high-comfort office commute. Backed by trained chauffeurs and advanced safety monitoring, it ensures a premium travel experience for corporate clients."
},
{
"name": "Company Cab Bagmane",
"description": "Company Cab Bagmane offers end-to-end corporate cab solutions including employee travel, executive transportation, and visitor movement. The service includes managed fleet coordination, maintenance handling, skilled drivers, and safety-oriented operations tailored for companies based in Bagmane Tech Park."
},
{
"name": "Staff Commute Bagmane",
"description": "Staff Commute Bagmane provides structured staff mobility operations with real-time trip management, optimized routing, safe driving standards, and dedicated support. It is ideal for companies managing large employee bases and helps streamline daily commute operations efficiently and reliably."
},
{
"name": "Corporate Fleet C.V. Raman Nagar",
"description": "Corporate Fleet C.V. Raman Nagar offers comprehensive fleet outsourcing solutions for businesses seeking long-term mobility support. With a managed lineup of sedans, SUVs, and employee shuttles, the service ensures professional driver management, maintenance coverage, compliance tracking, and scalable fleet availability for companies in C.V. Raman Nagar."
}
],

"tableData": [
["Bagmane IT Park Cab", "C.V. Raman Nagar Employee Transport"],
["Corporate Shuttle Bagmane", "Office Pickup Drop Bagmane"],
["Employee Cab Bagmane Tech Park", "Business Cab Bagmane"],
["Monthly Staff Shuttle Bagmane", "Best Corporate Cabs Bagmane"],
["Affordable Cab Bagmane", "Outstation Cab Bagmane"],
["Sedan Cab Bagmane", "SUV Cab Bagmane"],
["Company Cab Bagmane", "Staff Commute Bagmane"],
["Corporate Fleet C.V. Raman Nagar", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Bagmane Tech Park C.V. Raman Nagar",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Bagmane Tech Park, C.V. Raman Nagar, ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Bagmane Tech Park and nearby corporate hubs, helping professionals reach offices and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs deliver safe, courteous, and disciplined travel, ensuring a comfortable and secure commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible cab rental plans tailored to meet the commuting needs of businesses and employees in Bagmane Tech Park and C.V. Raman Nagar."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]
































  }

const faqData = [
  {
    question: 'Do you offer corporate cab services in Bagmane Tech Park, C.V. Raman Nagar?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services for companies in Bagmane Tech Park, C.V. Raman Nagar.',
  },
  {
    question: 'What types of corporate cab services are available in Bagmane Tech Park?',
    answer: 'We offer employee transportation, corporate pickups and drops, shuttle routes, airport transfers, and fully managed fleet solutions for IT companies.',
  },
  {
    question: 'Do you support daily employee commute services for Bagmane Tech Park?',
    answer: 'Yes, we provide well-organized daily commute services with smart route optimization, punctual pickups, and multi-shift transportation.',
  },
  {
    question: 'How can companies book corporate cab services in Bagmane Tech Park?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'What vehicle options do you offer for corporate cab services?',
    answer: 'We provide sedans, hatchbacks, SUVs, Innova Crysta, luxury cars, and tempo travellers based on company requirements.',
  },
  {
    question: 'Do you offer long-term corporate transportation contracts?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and complete fleet management.',
  },
  {
    question: 'Are the cabs equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and operated by trained, background-verified chauffeurs to ensure maximum safety.',
  },
  {
    question: 'Do you support night shift and rotational shift cab services?',
    answer: 'Yes, we manage transportation for night, early morning, weekend, and rotational shift schedules for employees working in Bagmane Tech Park.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and offer consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Venkatesh',
    feedback: 'Excellent corporate cab service for our Bagmane Tech Park office. Reliable, professional, and always on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Tanya Mohan',
    feedback: 'Great experience with their employee transportation services. Clean vehicles and courteous drivers every day.',
    rating: 5,
  },
];



































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Bagmane Tech Park C.V. Raman Nagar",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-bagmane-tech-park.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Bagmane Tech Park C.V. Raman Nagar, including employee transport, corporate shuttles, office pickup & drop, staff commute solutions, business cabs, monthly cab plans, outstation trips, and corporate fleet services for companies operating in Bagmane Tech Park and C.V. Raman Nagar.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-bagmane-tech-park-cv-raman-nagar"
  }
};









  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Bagmane Tech Park C.V. Raman Nagar | Employee & Business Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Bagmane Tech Park C.V. Raman Nagar including employee transport, corporate shuttle, office pickup & drop, staff commute, business cabs, monthly cab plans, outstation trips, and corporate fleet services."
  />

  <meta
    name="keywords"
    content="Bagmane IT Park Cab, C.V. Raman Nagar Employee Transport, Corporate Shuttle Bagmane, Office Pickup Drop Bagmane, Employee Cab Bagmane Tech Park, Business Cab Bagmane, Monthly Staff Shuttle Bagmane, Best Corporate Cabs Bagmane, Affordable Cab Bagmane, Outstation Cab Bagmane, Sedan Cab Bagmane, SUV Cab Bagmane, Company Cab Bagmane, Staff Commute Bagmane, Corporate Fleet C.V. Raman Nagar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinbagmane;